import file32 from '../assets/file32.png';
import file48 from '../assets/file48.png';
import file96 from '../assets/file96.png';
import icon from '../assets/Icon.png';
import man from '../assets/man.png';
import man1 from '../assets/man1.png';
import man2 from '../assets/man2.png';
import recs2 from '../assets/recs2.png';
import PB1 from '../assets/PB1.png';
import PB2 from '../assets/PB2.png';
import PB3 from '../assets/PB3.png';
import PB4 from '../assets/PB4.png';
import PB5 from '../assets/PB5.png';
import recs1 from '../assets/recs1.png';
import tick16 from '../assets/tick16.png';
import tick24 from '../assets/tick24.png';
import tick28 from '../assets/tick28.png';
import Uploading from '../assets/Uploading.png';

export default {
    file32,
    file48,
    file96,
    icon,
    man,
    man1,
    man2,
    PB1,
    PB2,
    PB3,
    PB4,
    PB5,
    recs1,
    recs2,
    tick16,
    tick24,
    tick28,
    Uploading,
};
